/* eslint-disable react/button-has-type */
import React, { useRef, useState, useEffect } from 'react';
import clsx from 'clsx';
import { Link, useNavigate } from 'react-router-dom';
import { ReactComponent as IconVolumeMute } from 'images/volumeMute.svg';
import { ReactComponent as IconVolumeFull } from 'images/volumeFull.svg';
import { getPercent } from 'sdk/utils/assets';
import { useTypedSelector } from 'store/useTypedSelector';
import { useActions } from 'store/useActions';
import styles from './Post.module.scss';

let interval: NodeJS.Timeout | undefined

function Post(props: any) {
  const post = props?.data?.data
  const className = props?.className
  const sortedAssetsById = props?.noAssets ? [] : post?.assets?.sort((a, b) => {
    if (a.id === props?.firstAssetId) return -1;
    if (b.id === props?.firstAssetId) return 1;
    return 0;
  })

  const videoRef = useRef<HTMLVideoElement>(null)
  const [isHovered, setIsHovered] = useState(false);
  const { isSoundOn } = useTypedSelector((state) => state.postSlice)
  const { setIsSoundOn } = useActions()
  const { isBecomeOnline } = useTypedSelector((state) => state.postSlice)

  const startVideo = () => {
    if (videoRef.current) {
      videoRef.current.play();
    }
  };

  const stopVideo = () => {
    if (videoRef.current) {
      videoRef.current.pause();
    }
  };

  useEffect(() => {
    const videoEl = videoRef.current;
    return () => {
      if (videoEl) {
        videoEl.pause()
      }
    }
  }, [])

  useEffect(() => {
    if (isBecomeOnline || isHovered) {
      startVideo()
    }
  }, [isBecomeOnline, isHovered])

  useEffect(() => () => {
    if (interval) clearInterval(interval)
  }, [])

  useEffect(() => {
    if (!props?.isActive) {
      stopVideo()
    } else {
      startVideo()
    }
  }, [props?.isActive])

  const navigate = useNavigate()

  return (
    <div
      className={clsx(
        className,
        styles.container,
        (!props?.grid && props?.size) && styles[`containerSize-${props?.size}`],
        (props?.grid && props?.gridItemSize) && styles[`containerSize-grid-${props?.gridItemSize}`],
      )}
      style={props?.style}
      onClick={() => {
        if (props?.noNavigation) return;
        if (props?.manualLink) {
          navigate(props?.manualLink, { state: { activeIndex: props?.activeIndex } })
        } else if (props?.feedId && props?.feedName) {
          navigate(`/user/feed/${props?.feedName}/${props?.feedId}/${props?.data?.id || ''}`, { state: { activeIndex: props?.activeIndex } })
        }
      }}
      onMouseEnter={() => {
        setIsHovered(true);
        startVideo();
      }}
      onMouseLeave={() => {
        setIsHovered(true);
        stopVideo();
      }}
    >
      <img src={post?.bg_cover || post?.video_link?.replace('upload', 'upload/so_0').replace(/\.\w+$/, '.jpg')} alt="bg_cover" />
      {
        isHovered && (
          <video
            src={post?.video_link}
            poster={post?.bg_cover || post?.video_link?.replace('upload', 'upload/so_0').replace(/\.\w+$/, '.jpg')}
            autoPlay={false}
            ref={videoRef}
            preload="none"
            muted={!isSoundOn}
          />
        )
      }

      {post?.tradingPlatform ? (
        <>
          <div className={styles.containerInfoTop}>
            <div className={styles.catRow}>
              <div className={styles.tradingIcon}>
                <img src={post?.tradingPlatform?.logo} alt={post?.tradingPlatform?.name} />
              </div>
            </div>
          </div>

          <div className={styles.containerInfoBottom}>
            <div className={styles.tradingTitle}>
              {post?.tradingPlatform?.name}
            </div>
          </div>
        </>
      ) : (
        <>
          <div className={styles.containerInfoTop}>
            {sortedAssetsById?.length ? (
              <div className={styles.catRow}>
                {(sortedAssetsById || []).slice(0, 1).map((v: any) => (
                  <div key={v?.id} className={styles.catIcon}>
                    {v ? (<img src={v?.icon} alt={v?.name} />) : null}
                  </div>
                ))}
              </div>
            ) : null}
            {
              sortedAssetsById?.[0] && getPercent(sortedAssetsById?.[0]) !== 0 && (
                <div className={styles.change}>
                  {
                    `${getPercent(sortedAssetsById?.[0])}%`
                  }
                </div>
              )
            }
          </div>

          <div className={styles.containerInfoBottom}>
            <div className={styles.userRow}>
              <div
                className={styles.usernameCol}
                onClick={(e: React.SyntheticEvent) => {
                  e.stopPropagation()
                }}
              >
                <Link
                  to={`/profile/${post?.profile?.username}`}
                  className={styles.username}
                >
                  @
                  <span>{post?.profile?.username}</span>
                </Link>
              </div>
            </div>
            <div className={styles.title}>
              {post?.description}
            </div>

            {/* <div className={styles.videoProgressContainer}>
              <div
                className={styles.videoProgress}
                // style={{ width: `${videoProgress || 0}%` }}
              />
            </div> */}
          </div>
        </>
      )}
      <button
        className={styles.soundButton}
        onClick={(e: any) => {
          e.stopPropagation()
          e.preventDefault()
          setIsSoundOn(!isSoundOn)
        }}
      >
        {isSoundOn ? <IconVolumeFull /> : <IconVolumeMute />}
      </button>
    </div>
  )
}

export default Post
